import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { PgPage } from '../common/PgPage';
import { FxConversionsList } from './FxConversionsList';
import { NotificationsView } from './NotificationsView';
import { OutboxList } from './OutboxList';
import { ReconciliationView } from './ReconciliationView';
import { WebhooksList } from './WebhooksList';

type TMonitoringView = 'webhooks' | 'reconciliation' | 'outbox' | 'emails' | 'fx';

const VIEWS: { value: TMonitoringView; label: string }[] = [
	{ value: 'webhooks', label: 'Webhooks' },
	{ value: 'reconciliation', label: 'Reconciliation' },
	{ value: 'outbox', label: 'Outbox' },
	{ value: 'emails', label: 'E-mails' },
	{ value: 'fx', label: 'FX conversions' },
];

const VIEW_COMPONENTS: Record<TMonitoringView, FC> = {
	webhooks: WebhooksList,
	reconciliation: ReconciliationView,
	outbox: OutboxList,
	emails: NotificationsView,
	fx: FxConversionsList,
};

/** Monitoring (03 §4.10–4.13): webhooks, reconciliation, outbox, e-mails and FX conversions. */
export const Monitoring: FC = () => {
	const navigate = useNavigate();
	const [view, setView] = useState<TMonitoringView>('webhooks');

	const handleViewChange = (_event: unknown, next: TMonitoringView | null) => {
		if (!next || next === view) return;
		// The lists share the URL query (page, sort, filters): start the next one clean.
		navigate({ search: '' }, { replace: true });
		setView(next);
	};

	const Content = VIEW_COMPONENTS[view];

	return (
		<PgPage title="Monitoring">
			<Box sx={{ mb: 1 }}>
				<ToggleButtonGroup size="small" exclusive value={view} onChange={handleViewChange}>
					{VIEWS.map((item) => (
						<ToggleButton key={item.value} value={item.value}>
							{item.label}
						</ToggleButton>
					))}
				</ToggleButtonGroup>
			</Box>
			<Content />
		</PgPage>
	);
};
